(function () {
  function localizeLinks(container) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root || root === '/') return;
    var prefix = root.replace(/\/$/, '');
    var links = [];
    if (container.matches && container.matches('a[href]')) links.push(container);
    if (container.querySelectorAll) links = links.concat(Array.from(container.querySelectorAll('a[href]')));
    links.forEach(function (link) {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!/^\/(collections|products|pages|blogs|policies|search|cart)(?:\/|$)/.test(url.pathname)) return;
      link.href = prefix + url.pathname + url.search + url.hash;
    });
  }
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('form.oright-language')) return;
    var returnTo = event.target.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  });
  localizeLinks(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) { if (node.nodeType === 1) localizeLinks(node); });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
